import { css, html, LitElement } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';

export const props = {
  size: { type: String },
};

/**
 *
 * @attr {xxs|xs|s|m|l|custom} size размер иконки
 * @export
 * @class UcIcon
 * @extends {LitElement}
 */
export class UcIcon extends LitElement {
  static get properties() {
    return props;
  }

  static get styles() {
    return css`
      :host {
        --icon-size: 100%;
        --icon-color: currentColor;

        display: block;
        width: var(--icon-size);
        height: var(--icon-size);

        font-size: 0;
      }

      :host,
      ::slotted(*) {
        fill: var(--icon-color);
      }

      ::slotted(*) {
        width: 100%;
        height: 100%;
      }

      :host([size='xxs']) {
        --icon-size: ${pxToRem(8)};
      }

      :host([size='xs']) {
        --icon-size: ${pxToRem(12)};
      }

      :host([size='s']) {
        --icon-size: ${pxToRem(16)};
      }

      :host([size='m']) {
        --icon-size: ${pxToRem(24)};
      }

      :host([size='l']) {
        --icon-size: ${pxToRem(32)};
      }
    `;
  }

  constructor() {
    super();

    this.size = 'custom';
  }

  updated(_changedProperties) {
    if (_changedProperties.has('size')) {
      const value = parseInt(this.size, 10);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(value)) return;

      this.style.setProperty('--icon-size', `${pxToRem(value)}`);
    }
  }

  render() {
    return html` <slot></slot> `;
  }
}
